import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../Store/store';

const AuthRedirect = ({ children }: { children: React.ReactNode }) => {
  const isLoggedIn = useAppSelector(state => state.user.isLoggedIn);
  const role = useAppSelector(state => state.user.role);

  if (isLoggedIn) {
    if (role === "admin") {
      return <Navigate to="/admin" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default AuthRedirect;